import { AxiosError } from 'axios'
import { isArray } from 'lodash'
import toast from 'react-hot-toast'

/**
 * Parse flash messages and transform it to array
 */
export const getFlashMessagesFn = ({
  flash,
  metricCode,
}: {
  flash: string[] | Record<'all' | string, string[]>
  metricCode: string
}): string[] => {
  if (isArray(flash)) {
    return flash
  }
  const recordFlash = flash as Record<'all' | string, string[]>

  return [...(recordFlash?.all || []), ...(recordFlash?.[metricCode] || [])].filter(Boolean)
}

/**
 * Flash messages carried by a failed request (e.g. 400 unknown dimension). SNOW-8774
 */
export const getErrorFlashMessagesFn = (error: unknown): string[] => {
  const flash = (error as AxiosError<{ flash?: unknown }>)?.response?.data?.flash
  return isArray(flash) ? flash : []
}

/**
 * Toast the flash messages of a failed request, once per message even if several widgets fail
 */
export const toastErrorFlashFn = (error: unknown): boolean => {
  const messages = getErrorFlashMessagesFn(error)
  messages.forEach(message => toast.error(message, { id: message }))
  return messages.length > 0
}
